import { render, staticRenderFns } from "./AdditionalExpenseList.vue?vue&type=template&id=0154e3bf&"
import script from "./AdditionalExpenseList.vue?vue&type=script&lang=js&"
export * from "./AdditionalExpenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports